import { combineReducers } from "redux";
import getProfileOverviewReducer from "./getProfileOverviewReducer";
import getProfileDetailsReducer from "./getProfileDetailsReducer";
import putProfileAttributesReducer from "./putProfileAttributesReducer";
import getProfileByRollReducer from "./getProfileByRollReducer";
import getProfileAttributesReducer from "./profileAttributes/getAttributesReducer";
import getAllProfilesByRollReducer from "./getAllProfilesByRollReducer";
import getPreviousProfileAttributesReducer from "./profileAttributes/getPreviousAttributesReducer";

const profileReducer = combineReducers({
  getProfileOverview: getProfileOverviewReducer,
  getProfileDetails: getProfileDetailsReducer,
  getProfileAttributes: getProfileAttributesReducer,
  putProfileAttributes: putProfileAttributesReducer,
  getProfileByRoll: getProfileByRollReducer,
  getAllProfilesByRoll: getAllProfilesByRollReducer,
  getPreviousProfileAttributes: getPreviousProfileAttributesReducer
});

export default profileReducer;